import { IEvent } from "../../../models/Event"
import {HeatBox} from "./components/HeatBox"

export const Heats:React.FC<{event: IEvent}> = ({event}) => {
    return (
        <section className="section main-heats">
            <div className="container">
                <h2 className="section-title">המקצים</h2>
                <div className="heats-container">
                    {event.heats.map(heat =>
                        <HeatBox key={heat.description} heat={heat} event={event}/>
                    )}
                </div>
            </div>
        </section>
    )
}
